import { adminService } from './api';

class AdminResultsService {
  /**
   * Get participants with their submitted stories for an event
   */
  async getParticipantsWithStories(eventId) {
    try {
      const response = await adminService.getParticipantsWithStories(eventId);
      return response.data;
    } catch (error) {
      console.error('Error getting participants with stories:', error);
      throw error;
    }
  }

  /**
   * Get current results for an event
   */
  async getEventResults(eventId) {
    try {
      const response = await adminService.getEventResults(eventId);
      return response.data;
    } catch (error) {
      console.error('Error getting event results:', error);
      throw error;
    }
  }

  /**
   * Set the winner for an event
   */
  async setWinner(eventId, winnerData) {
    try {
      const response = await adminService.setWinner(eventId, winnerData);
      return response.data;
    } catch (error) {
      console.error('Error setting winner:', error);
      throw error;
    }
  }

  /**
   * Set finalists for an event
   */
  async setFinalists(eventId, finalistsData) {
    try {
      const response = await adminService.setFinalists(eventId, finalistsData);
      return response.data;
    } catch (error) {
      console.error('Error setting finalists:', error);
      throw error;
    }
  }

  /**
   * Publish results for an event
   */
  async publishResults(eventId) {
    try {
      const response = await adminService.publishResults(eventId);
      return response.data;
    } catch (error) {
      console.error('Error publishing results:', error);
      throw error;
    }
  }

  /**
   * Unpublish results for an event
   */
  async unpublishResults(eventId) {
    try {
      const response = await adminService.unpublishResults(eventId);
      return response.data;
    } catch (error) {
      console.error('Error unpublishing results:', error);
      throw error;
    }
  }

  /**
   * Delete all results for an event
   */
  async deleteResults(eventId) {
    try {
      const response = await adminService.deleteResults(eventId);
      return response.data;
    } catch (error) {
      console.error('Error deleting results:', error);
      throw error;
    }
  }
}

export const adminResultsService = new AdminResultsService();
